import React from 'react'
import { Card, CardBody, Row, Col, } from 'reactstrap'
import { BeatLoader } from 'react-spinners'
import { getAssessSelectorNavLinks, findCompositeScore, getCompositeCircleData } from '../../../helpers/assessment/assessmentDashboard';
import AssessDashStartOrResume from '../AssessDashStartOrResume';
import AssessDashCircle from '../AssessDashCircle';
import SubCirclesRow from './SubCirclesRow';
import AssessSelectorNav from '../AssessSelectorNav';

export default function TopCard ({
  groupUAId,
  userAssessmentId,
  userAssessment,
  isCompare,
  subtest,
  resume,
  sub,
  topComplete,
  isStudent,
  groupUA,
  printPath,
  notInitializing,
  scoring,
  scoringCompare,
  subtests,
  assessmentId,
  selectedGroupUA,
  selectedStudent,
  user,
  groupUAs,
  xs, sm, md, lg, xl,
  currentAssessmentId,
  test1,
  test2,
  isSwap,
  year
}) {
  const compositeScore = findCompositeScore(scoring, isStudent, selectedStudent)
  const compositeScoreCompare = findCompositeScore(scoringCompare, isStudent, selectedStudent)
  const assessSelectorNavLinks = getAssessSelectorNavLinks(
    selectedGroupUA,
    isStudent,
    selectedStudent,
    user.role,
    userAssessment,
    assessmentId,
    groupUA,
    '',
    year
  )
  // const compositeCircleData = getCompositeCircleData(subtests, scoring, compositeScore)

  return (
    <Col {...{xs, sm, md, lg, xl}}>
      <Card className='top-card'>
        <CardBody>
          <Row>
            <Col xs='12' lg='4' className='test-progress'>
              {groupUAId || (userAssessmentId && userAssessment)
                ? <AssessDashStartOrResume
                  subtest={subtest}
                  resume={resume}
                  userAssessmentId={userAssessmentId}
                  groupUAId={groupUAId}
                  sub={sub}
                  topComplete={topComplete}
                  isStudent={isStudent}
                  groupUA={groupUA}
                  selectedStudent = {selectedStudent}
                  userAssessment={userAssessment}
                  printPath={printPath}
                  // licenseExpired={licenseExpired}
                />
                :
                <div className='loading-animation' style={{height: '180px'}}>
                  <BeatLoader loading={!notInitializing} color={"#00C1AB"} />
                </div>
              }
            </Col>
            {/* Composite Donut in Top Card */}
            <Col className='top-card-donut-chart-container' xs='12' lg='8' xl='8'>
              <Row>
                <Col xs='12' sm='5' md='4' lg='5' xl='3' className="composite-donut">
                  {subtests &&
                    <AssessDashCircle 
                      {...getCompositeCircleData(subtests, scoring,scoringCompare, compositeScore ,notInitializing , compositeScoreCompare , test1 , test2, isSwap)} isCompare = {isCompare}
                    />
                  }
                  
                  <div className='loading-animation'>
                    <BeatLoader loading={!subtests && !notInitializing} color={"#00C1AB"} />
                  </div>
                </Col>
                <Col xs='12' sm='7' md='8' lg='7' xl='9' className="subject-donuts">
                  {subtests && 
                    <SubCirclesRow 
                      subtests={subtests}
                      scoring={scoring}
                      scoringCompare ={scoringCompare}
                      isStudent={isStudent}
                      selectedStudent={selectedStudent}
                      selectedGroupUA={selectedGroupUA}
                      userAssessment={userAssessment}
                      assessmentId={assessmentId}
                      user={user}
                      groupUAs={groupUAs}
                      userAssessmentId={userAssessment && userAssessment.userAssessmentId}
                      isCompare = {isCompare}
                      currentAssessmentId = {currentAssessmentId}
                      test1 = {test1}
                      test2 = {test2}
                      isSwap = {isSwap}
                      year={ year }
                    />
                  }
                  <div className='loading-animation'>
                    <BeatLoader loading={!subtests && !notInitializing} color={"#00C1AB"} />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </CardBody>
        <AssessSelectorNav {...assessSelectorNavLinks} />
      </Card>
    </Col>
  )

}



// WEBPACK FOOTER //
// ./src/components/Assessment/AssessDash/TopCard.js